import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Features() {
  const navigate = useNavigate();

  // The 8 Core Features from the layout grid
  const coreFeatures = [
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Instant 60-Second Response",
      desc: "Answers every call immediately, even after hours."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: "Smart AI Qualification",
      desc: "Identifies high-value emergencies vs routine jobs."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      title: "Automatic Appointment Booking",
      desc: "Books directly into your calendar with confirmation."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 8H18.5M7 12l3 3L20 5" />
        </svg>
      ),
      title: "24/7 Availability",
      desc: "Never miss a lead while sleeping, on vacation, or on a job."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: "Location-Aware Routing",
      desc: "Sends urgent calls to the nearest technician."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12 c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      title: "Natural Conversation",
      desc: "Sounds human, asks the right questions, handles objections."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h2a2 2 0 002-2zm12 0v-3a2 2 0 00-2-2h-2a2 2 0 00-2 2v3a2 2 0 002 2h2a2 2 0 002-2zm0 0v-7a2 2 0 00-2-2h-2a2 2 0 00-2 2v7a2 2 0 002 2h2a2 2 0 002-2z" />
        </svg>
      ),
      title: "Detailed Call Reports",
      desc: "Get transcripts, lead quality scores, and revenue insights."
    },
    {
      icon: (
        <svg className="w-5 h-5 text-[#d946ef]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      ),
      title: "Seamless Integrations",
      desc: "Works with your existing scheduling software, CRM, and phone system."
    }
  ];

  return (
    <div className="bg-[#030712] min-h-screen text-white font-sans antialiased flex flex-col justify-between">
      
      {/* GLOBAL NAVIGATION HEADER */}
      <nav className="border-b border-gray-900/80 bg-[#030712]/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          
          {/* Logo Construct */}
          <div onClick={() => navigate('/')} className="flex items-center gap-2.5 cursor-pointer select-none group">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-magenta to-brand-purple flex items-center justify-center shadow-lg shadow-purple-500/20 group-hover:scale-105 transition-transform">
              <span className="text-white text-lg font-bold">⚡</span>
            </div>
            <span className="text-xl font-extrabold tracking-tight text-white">
              Atlas <span className="text-brand-purple">AI</span>
            </span>
          </div>

          {/* Navigation Items */}
          <div className="hidden sm:flex items-center gap-8 text-sm font-medium text-gray-400">
            <button onClick={() => navigate('/')} className="hover:text-white transition-colors">Home</button>
            <span className="text-brand-purple border-b-2 border-brand-purple pb-1 cursor-default">Features</span>
            <button onClick={() => navigate('/calculator')} className="hover:text-white transition-colors">Calculator</button>
            <button onClick={() => navigate('/media')} className="hover:text-white transition-colors">Media</button>
            <button onClick={() => navigate('/contact')} className="hover:text-white transition-colors">Contact</button>
          </div>
        </div>
      </nav>

      {/* MAIN CONTAINER WORKSPACE */}
      <main className="flex-grow w-full">
        
        {/* HERO HEADER SECTION */}
        <section className="max-w-7xl mx-auto px-6 pt-20 pb-4 text-center space-y-6">
          <div className="inline-block px-3 py-1 rounded-full bg-brand-purple/10 border border-brand-purple/20 text-[10px] font-black uppercase tracking-widest text-brand-purple font-mono">
            • Now Answering 50,000+ Calls Monthly
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight max-w-4xl mx-auto leading-tight">
            Powerful Features That <br />
            <span className="text-brand-magenta">Turn Missed Calls</span> Into Revenue
          </h1>

          <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Atlas AI handles every plumbing and electrical lead in 60 seconds — qualifying, booking, and routing automatically.
          </p>

          {/* HERO CTA BUTTON */}
          <div className="pt-4 pb-12 flex justify-center">
            <button 
              onClick={() => navigate('/calculator')}
              className="px-8 py-3.5 bg-gradient-to-r from-brand-magenta to-brand-purple hover:opacity-95 text-white text-sm font-bold rounded-full shadow-lg shadow-purple-500/10 hover:shadow-purple-500/20 active:scale-[0.99] transition-all tracking-wide inline-flex items-center gap-2 group cursor-pointer"
            >
              See How Much You're Losing 
              <span className="transform group-hover:translate-x-0.5 transition-transform">→</span>
            </button>
          </div>
        </section>

        {/* HOW IT WORKS SECTION */}
        <section className="max-w-7xl mx-auto px-6 py-16 border-t border-gray-900/40 text-center space-y-2">
          <h2 className="text-2xl md:text-3xl font-black tracking-tight text-white">
            How It Works
          </h2>
          <p className="text-gray-500 text-xs md:text-sm tracking-wide font-mono uppercase">
            Simple, automated, and incredibly effective
          </p>

          <div className="grid md:grid-cols-3 gap-8 pt-12 text-center">
            <div className="flex flex-col items-center space-y-3">
              <div className="w-10 h-10 rounded-full bg-brand-purple/20 border border-brand-purple text-brand-purple flex items-center justify-center font-bold">1</div>
              <h3 className="text-base font-bold text-white">Call comes in</h3>
              <p className="text-gray-400 text-xs max-w-xs leading-relaxed">AI answers in your voice, greeting the customer professionally.</p>
            </div>
            <div className="flex flex-col items-center space-y-3">
              <div className="w-10 h-10 rounded-full bg-brand-purple/20 border border-brand-purple text-brand-purple flex items-center justify-center font-bold">2</div>
              <h3 className="text-base font-bold text-white">AI qualifies lead</h3>
              <p className="text-gray-400 text-xs max-w-xs leading-relaxed">Gathers details, intent, and urgency level instantly.</p>
            </div>
            <div className="flex flex-col items-center space-y-3">
              <div className="w-10 h-10 rounded-full bg-brand-purple/20 border border-brand-purple text-brand-purple flex items-center justify-center font-bold">3</div>
              <h3 className="text-base font-bold text-white">Books or routes</h3>
              <p className="text-gray-400 text-xs max-w-xs leading-relaxed">Instantly books the job or routes high-value emergencies to your team.</p>
            </div>
          </div>
        </section>

        {/* CORE FEATURES SECTION GRID */}
        <section className="max-w-7xl mx-auto px-6 py-16 border-t border-gray-900/40 text-center space-y-3">
          <h2 className="text-3xl font-black tracking-tight text-white">
            Core Features
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto">
            Everything you need to automate your phone lines and scale your trades business.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 pt-12 text-left">
            {coreFeatures.map((feat, index) => (
              <div 
                key={index}
                className="bg-[#0b0f19]/40 border border-gray-900/60 rounded-2xl p-6 shadow-xl flex flex-col space-y-4 hover:border-gray-800 transition-colors"
              >
                <div className="w-10 h-10 rounded-xl bg-gray-900/80 flex items-center justify-center border border-gray-800/40">
                  {feat.icon}
                </div>
                <div className="space-y-2">
                  <h3 className="text-base font-bold text-white tracking-tight">{feat.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{feat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </main>

      {/* DUPLICATED MULTI-COLUMN GLOBAL FOOTER AREA (From image_33416c.png) */}
      <footer className="border-t border-gray-900/60 bg-[#02050c] pt-16 pb-8 text-gray-400 text-xs">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-4 pb-12">
          
          {/* Brand Column */}
          <div className="md:col-span-6 space-y-4">
            <div className="flex items-center gap-2 select-none">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-brand-magenta to-brand-purple flex items-center justify-center shadow-md">
                <span className="text-white text-xs font-bold">⚡</span>
              </div>
              <span className="text-base font-extrabold tracking-tight text-white">
                Atlas <span className="text-brand-purple">AI</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm max-w-sm leading-relaxed">
              The #1 AI phone answering service built specifically for plumbing and electrical businesses. Never miss a lead again.
            </p>
          </div>

          {/* Product Column */}
          <div className="md:col-span-3 space-y-3">
            <h4 className="text-white font-mono font-bold uppercase tracking-wider text-[11px]">Product</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><span className="text-brand-purple font-medium cursor-default">Features</span></li>
              <li><button onClick={() => navigate('/media')} className="hover:text-white transition-colors">Media</button></li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="md:col-span-3 space-y-3">
            <h4 className="text-white font-mono font-bold uppercase tracking-wider text-[11px]">Company</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><button onClick={() => navigate('/contact')} className="hover:text-white transition-colors">Contact</button></li>
              <li><button onClick={() => navigate('/about')} className="hover:text-white transition-colors">About</button></li>
              <li><button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors">Privacy Policy</button></li>
            </ul>
          </div>

        </div>

        {/* Sub-Footer Base Plate */}
        <div className="max-w-7xl mx-auto px-6 pt-6 border-t border-gray-950 flex flex-col sm:flex-row items-center justify-between gap-4 text-gray-600 font-mono text-[11px]">
          <p>© 2026 Atlas AI. Powered by real AI for trades businesses.</p>
          <div className="flex items-center gap-6">
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="hover:text-gray-400 transition-colors">Twitter</a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="hover:text-gray-400 transition-colors">LinkedIn</a>
          </div>
        </div>
      </footer>

    </div>
  );
}